import { render, staticRenderFns } from "./WameedWarningModal.vue?vue&type=template&id=4afe0203&"
import script from "./WameedWarningModal.vue?vue&type=script&lang=js&"
export * from "./WameedWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports